import {
  RegistrationEvent,
  type TrackRegistrationEventFn,
} from "./analytics";

/** Session flag so login + value-prop entry do not double-fire CreateAccountClicked. */
export const CREATE_ACCOUNT_CLICKED_SESSION_KEY =
  "fmc_analytics_create_account_clicked";

/**
 * Fires CreateAccountClicked at most once per browser session.
 * Used from login register CTA and direct /register landing (e.g. login-doc).
 */
export function trackCreateAccountClickedOnce(
  trackRegistrationEvent: TrackRegistrationEventFn,
): void {
  try {
    if (
      typeof sessionStorage !== "undefined" &&
      sessionStorage.getItem(CREATE_ACCOUNT_CLICKED_SESSION_KEY) === "1"
    ) {
      return;
    }

    trackRegistrationEvent(RegistrationEvent.CREATE_ACCOUNT_CLICKED);

    if (typeof sessionStorage !== "undefined") {
      sessionStorage.setItem(CREATE_ACCOUNT_CLICKED_SESSION_KEY, "1");
    }
  } catch {
    // Analytics must not block navigation
  }
}
